<template>
    <div class="content-wrapper full-page-wrapper auth-pages login-2 col-12 pt-0 pb-0"   style="overflow:no-display;">
        <span v-if="transaction" style="position: absolute;right:2%;top:5%;z-index: 9999999999!important;">
             <v-btn class="mx-2"
                    @click="cancelTransaction"
                     fab
                     dark
                     small
                     color="red">
      <v-icon dark color="white">
        mdi-close
      </v-icon>
    </v-btn>
        </span>

        <PaymentGateFirst v-if="transaction && getTemplate()==='VksSmmaq'"></PaymentGateFirst>
        <PaymentGateSecond v-if="transaction &&  getTemplate()==='vO0vKBCd'"></PaymentGateSecond>
     
     <div v-if="transaction">
          <vue-html2pdf
                :show-layout="false"
                :float-layout="false"
                :enable-download="true"
                :preview-modal="false"
                :paginate-elements-by-height="1400"
                :filename="'invoice_'+transaction._store.name.replace(' ','_')+'_'+today().replace(' ','_')"
                :pdf-quality="1"
                :manual-pagination="false"
                pdf-format="a4"
                pdf-orientation="portrait"
                pdf-content-width="800px"
                ref="html2Pdf"> 
                <InvoiceFirst slot="pdf-content" :transaction="transaction"></InvoiceFirst>
        </vue-html2pdf>
        <div class="btnInvoice" v-if="viewPdf">
            <button class="btn btn-light btn-sm" @click="closePdf()">Retour</button>
            <button class="btn btn-primary btn-sm" @click="downLoadPdf()">Télécharger</button>
        </div>
     </div>
    
       <div v-if="error" class="col-lg-12">
           <div class="col-lg-12">
               <div class="row">
           <div class="col-lg-4"></div>
            <div class="text-justify col-lg-4 col-12 card" style="margin-top:15vh;min-height:auto!important">
                <div class="card-body">
                <img v-lazy="'/images/logo_large.png'" width="100px" alt="" class="mb-3"> 
                <h3>Désolé nous ne pouvons pas finaliser votre paiement pour le moment.</h3>
                <p>Certaines situations peuvent bloquer votre paiment</p>
                <ul>
                    <li>Le montant à payer ne suis pas le format imposé.</li>
                    <li>Ce lien n'est plus disponible pour paiement ou à été déjà cloturé</li>
                </ul>
                <p><button class="btn btn-primary btn-sm">Retourner  chez le marchand</button></p>
                </div>
            </div>
            </div>
            </div>
        </div>
        <div class="loader" v-if="!transaction && !error">
               <div class="loading">
                   <img v-lazy="'/images/logo_mini_intram.jpg'" width="100px" alt="">
               </div>
           </div>
       
    </div>
</template>

<script>
    /* eslint-disable*/
    import {mapState} from "vuex";
    import helpers from "../../mixins/helpers";
    const STRIPE_PUBLIC_KEY= "pk_live_51IDz5vKcJ3VN9i5zlXXn0wgNLCL37PNRivB6uAdQf61RhJgajgT3c9lgvKxSjWVPqB3O5ivkajhS1Pb28mi427Ep0022BuxPwy";
    const STRIPE_PUBLIC_TEST_KEY= "pk_test_51IBHYsDQ6Dx49K3FzPI3tS7L7I7WjQ1VNN4nxiZcblHqVpfsh4i7eqrAXJ71SXXUt1VkLwwoj16Hfoo70NurHwbq00OxGGetxZ";


    import VueHtml2pdf from 'vue-html2pdf'
    import $ from 'jquery'
    export default {
        name: "PaymentGate",
        mixins:[helpers(this)],
         components: {
             VueHtml2pdf
        },
        data (){
            return {
                stripe:undefined,
                  htmlToPdfOptions: {
                    margin: 0,
                    image: {
                        type: 'jpeg',
                        quality: 0.95
                    },
                    enableLinks: true,
                    html2canvas: {
                        scale: 1,
                        useCORS: true
                    },
                    jsPDF: {
                        unit: 'in',
                        format: 'a4',
                        orientation: 'portrait'
                    }
                },
                viewPdf:false,
                paid_by:'qr',
                manual_pay:'mobile_money',
                submitting:false,
                submitted:false,
                valid:false,
                mean:'mobile',
                template:'payment-gate-second',
                rules:{
                    lastNameRules: [
                        v => !!v || this.$t('last_name_required'),
                        //v => (v && v.length <= 10) || 'Name must be less than 10 characters',
                    ],
                    firstNameRules: [
                        v => !!v || this.$t('first_name_required'),
                        //v => (v && v.length <= 10) || 'Name must be less than 10 characters',
                    ],
                    phoneRules: [
                        v => !!v || this.$t('phone_required')
                      //  v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
                    ],
                },
                num_source:'',
                first_name:null,
                last_name:null,
                errors:{},
            }
        },

        computed: {
            ...mapState('payments/', ['transaction', 'error', 'message','templates','client_secret'])
        },
        mounted (){
            if (this.$route.params.transaction_id){
                this.$store.dispatch('payments/getPaymentGateTransaction',this.$route.params.transaction_id).then((response)=>{
                    console.log('transaction',response)

                })
           }
            this.$store.dispatch('generalsettings/getGeneralSetting').then(() => {});

        },

        methods:{
            cancelTransaction(){
                if (this.transaction._actions && this.transaction._actions.cancel_url){
                    window.location = this.transaction._actions.cancel_url+"?transaction_id="+this.transaction._reference+"&cancel=true";
                }else{
                    history.back()//+"?transaction_id="+this.transaction._ref+"&cancel=true"
                }
            },
        generateReport () {  
                this.$refs.html2Pdf.generatePdf();
                this.toast('success','Opération en cours ...')
         },
    closePdf(){
    this.viewPdf=false;
    },
            downLoadPdf(){
 this.$refs.html2Pdf.generatePdf();
                this.toast('success','Opération en cours ...')
            },
             today(){
                let today = new Date(),
                 dd = String(today.getDate()).padStart(2, '0'),
                 mm = String(today.getMonth() + 1).padStart(2, '0'), //January is 0!
                 yyyy = today.getFullYear();
               return  mm + '-' + dd + '-' + yyyy;

            },
            detailsAction(){
              $('.detail_paiement').slideToggle();
            },
            checkisDashboard(){
                this.$emit('checkisDashboard',false);
            },
            resetDatas(component){
                Object.assign(component.$data, component.$options.data.apply(component))
            },
            getTemplate(){
           // console.log('tranasction ==>',this.transaction)
                let ref = '';
                if (this.transaction.marchand._template && this.transaction.marchand._template.length>0){
                    let template = this.transaction.marchand._template.find((temp)=>temp._ref===this.transaction._store.template);
                    let checkIfExist = this.templates.find((temp)=>temp._ref===this.transaction._store.template);
                    if (template && checkIfExist){
                        ref = this.transaction._store.template;
                    }else{
                        ref = 'VksSmmaq';
                    }
                }else{
                    ref = 'VksSmmaq';
                }
                return ref;
            },
        },
        created() {
            this.checkisDashboard();
        },

    }

</script>

<style scoped>
.modeSandboxActive{
        width: 100%;
    padding: 5px 10px 0px 10px;
    background: goldenrod;
    color: #fff;
    text-align: center;
    font-size: 8pt;
    text-transform: uppercase;
}
.modeSandboxActiveBottom{
    position: fixed;
    bottom: 0;
    z-index: 999999999;
}
.sandbox-title{
  background-color: rgba(255,165,0,0.4);
}
.sandbox-mode{
  /*border: 10px solid orange;*/
}
.auth-pages.login-2.login-2, .auth-pages.option-2.login-2{
background: #e1e1e3;
}
    .error-message-load{
        font-size: 12pt;
        font-weight: bold;
        text-transform: uppercase;
        color: #ff640a;
    }
    .loader{
        z-index: 999;
        text-align: center;
        min-width: 100vw;
        background: #f8f8f8;
        min-height: 100vh;
        position: absolute;
        top: 0;
    }
    .loading{
        position: absolute;
        left: 45%;
        top: 40%;
        z-index: 1;
        padding: 0;
        margin: 0;
        background: #f8f8f8;
        -webkit-animation: flickerAnimation 2s infinite;
        -moz-animation: flickerAnimation 2s infinite;
        -o-animation: flickerAnimation 2s infinite;
        animation: flickerAnimation 2s infinite;
    }

    @keyframes flickerAnimation {
        0%   { opacity:1; }
        50%  { opacity:0.1; }
        100% { opacity:1; }
    }
    @-o-keyframes flickerAnimation{
        0%   { opacity:1; }
        50%  { opacity:0.1; }
        100% { opacity:1; }
    }
    @-moz-keyframes flickerAnimation{
        0%   { opacity:1; }
        50%  { opacity:0; }
        100% { opacity:1; }
    }

    @-webkit-keyframes flickerAnimation{
        0%   { opacity:1; }
        50%  { opacity:0; }
        100% { opacity:1; }
    }
.sandbox-title{
    position: fixed;
    right: 0;
    bottom: 0;
    z-index: 999999999999999999999;
}

@media (max-width:991px){
    .modeSandboxActive{
    bottom:0;
    
}
}

.btnInvoice{
    position:fixed;
    bottom: 0;
    width: 100%;
    padding: 10px;
    z-index: 999999999999999999999;
    text-align: center;
    background: #fff;
}
.btnInvoice .btn{
  margin-left: 10px;
}
.fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
}
</style>
